export default __webpack_public_path__ + "static/media/chronograph-watch.488bd73d.png";